import { render, staticRenderFns } from "./GroupMain.vue?vue&type=template&id=4f625065&scoped=true"
import script from "./GroupMain.vue?vue&type=script&lang=js"
export * from "./GroupMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f625065",
  null
  
)

export default component.exports